// extracted by css-extract-rspack-plugin
export default {"watch-button":"YuXv1k","watchButton":"YuXv1k"};